import categoryImage from '../../public/icons/category.jpg';
import './CollegeMetaInfoList.css';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import reportsLoader from '../../public/icons/loader.png';
import NOCourses from '../../public/icons/no_courses.jpg';

const UserCourseEnrollmentList = (props) => {
    const { getUserCourseEnrollmentList, universityCourseEnrollment } = props;
    const [courseEnrollmentList, setCourseEnrollmentList] = useState(null);
    const [enrollment, setEnrollment] = useState(null);
    const userId = localStorage.getItem("user_id");

    useEffect(() => {
        const fetchCourseEnrollmentList = async () => {
            try {
                const courseEnrollmentListResp = await getUserCourseEnrollmentList();
                if (courseEnrollmentListResp?.data) {
                    setCourseEnrollmentList(courseEnrollmentListResp.data);
                } else {
                    setCourseEnrollmentList(null);
                }
            } catch (error) {
                console.error("Error fetching course enrollment list:", error);
                setCourseEnrollmentList(null);
            }
        };
        fetchCourseEnrollmentList();
    }, [getUserCourseEnrollmentList]);

    const courseEnrollment = async (user_id, program_id, enroll_status) => {
        try {
            const courseEnrollmentResp = await universityCourseEnrollment(user_id, program_id, enroll_status);
            console.log("Response:", courseEnrollmentResp);      

            if (courseEnrollmentResp?.data) {
                alert('Successfully Unenrolled');
                // Remove the unenrolled course from the list
                setCourseEnrollmentList((prevList) =>
                    prevList.filter((course) => course.program_id !== program_id)
                );
            } else {
                alert('Failed to Unenroll');
            }
        } catch (error) {
            console.error("Error unenrolling from the course:", error);
        }
    };

    return (
        <div style={{ paddingTop: '100px', paddingLeft: '50px', paddingRight:'50px'}}>
            {courseEnrollmentList && courseEnrollmentList.length > 0 ? (
                <div className="news-container">
                    {courseEnrollmentList?.map((post, index) => (
                        <div className="news-item" key={index}>
                            <img
                                style={{ width: '100%', height: '120px' ,objectFit:'fill' }}
                                src={post?.program_image ?? NOCourses}
                                alt={post?.program_image}
                            />
                            <div className="news-content">
                                <h3 className="news-title">{post?.program_name ?? ''}</h3>
                                <p className="news-description">{post?.program_price ?? ''}</p>
                                {/* UnEnrolled button */}

                                <button
                                
                                    className="unenroll-button"
                                    onClick={() =>
                                        courseEnrollment(userId, post?.program_id, 0)
                                    }
                                >
                                    UnEnroll
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                // <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                //     <img src={reportsLoader} alt="Loading..." />
                // </div>
                <div 
                // style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh', // Full viewport height
                    width: '100%', // Full width
                    margin: 0, // Reset margins
                    padding: 0, // Reset padding
                    paddingLeft: '400px',
                    paddingBottom: '300px'
                  }}
                >
                  
                    <img src={reportsLoader} alt="Loading..." />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => {
    const { getUserCourseEnrollmentList, universityCourseEnrollment } = actions;
    return {
        getUserCourseEnrollmentList: () => dispatch(getUserCourseEnrollmentList()),
        universityCourseEnrollment: (user_id, program_id, enroll_status) =>
            dispatch(universityCourseEnrollment(user_id, program_id, enroll_status)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCourseEnrollmentList);
